import angular from "angular";

import OAuthModuleRouting from "./oauth.module.routing";

export default angular
    .module("vt-oauth", [])
    .config(OAuthModuleRouting);
